/**
 * Override of RequestOptionsArgs to add new properties
 */
import { HttpHeaders, HttpParams } from '@angular/common/http';

/**
 * Enumerable of all possible ReturnType. For now only HttpReponse value is used
 */
export enum ReturnType {
    HTTP_RESPONSE = 'HttpResponse',
    BODY = 'body',
}

export interface RequestOptions {
    /**
     * Feature name
     * @type {string}
     */
    feature?: string;
    /**
     * Functionality code for BCO logs
     * @type {string}
     */
    functionality?: string;
    /**
     * Page ID for BCO logs
     * @type {string}
     */
    pageId?: string;
    /**
     * Partner name for BCO logs
     * @type {string}
     */
    partner?: string;
    /**
     * Service name for BCO logs
     * @type {string}
     */
    service?: string;
    /**
     * Clear cache for this request and force call to service
     * @type {boolean}
     */
    force?: boolean;
    /**
     * Type of response (json, blob, ...)
     * @type {string}
     */
    responseType?: string;
    /**
     * List of Headers to append
     * @type {HttpHeader}
     */
    headers?: HttpHeaders;
    /**
     * Request timeout
     * @type {number}
     */
    timeout?: number;
    /**
     * Type of observer to be returned (body or httpResponse)
     * @type {ReturnType} only possible value is "httpResponse", any other value will return the body
     */
    returnType?: ReturnType;
    /**
     * Prevent default Content-Type to be set, let the browser compute it
     * @type {boolean}
     */
    disableContentTypeHeader?: boolean;
    /**
     * Parameters
     * @type {HttpParams | { [param: string]: string | string[]}}
     */
    params?: HttpParams | { [param: string]: string | string[] };
}
